import { Box } from "@mui/material";
import { Route, Routes } from "react-router";
import Header from "./components/Header/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import CreateVideo from "./pages/CreateVideo";
import Home from "./pages/Home";
import InteractiveVideo from "./pages/InteractiveVideo";
import MyVideo from "./pages/MyVideo";

export default function Main() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/video/:id" element={<InteractiveVideo />} />
        <Route
          path="/create-video"
          element={
            <ProtectedRoute>
              <CreateVideo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-video"
          element={
            <ProtectedRoute>
              <MyVideo />
            </ProtectedRoute>
          }
        />
      </Routes>

      <Box
        sx={{
          width: 1,
          height: "288px",
          backgroundImage: "url(/images/layout/footer.png)",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
    </>
  );
}
